import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=38da90f7&scoped=true&"
import script from "./WebFooter.vue?vue&type=script&lang=js&"
export * from "./WebFooter.vue?vue&type=script&lang=js&"
import style0 from "./WebFooter.vue?vue&type=style&index=0&id=38da90f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da90f7",
  null
  
)

export default component.exports